import { createApiSlice } from "@common";
import { CRUD_ORDER_TYPE } from "@routes";

const apiConfig = [
  {
    name: "addOrderType",
    method: "post",
    url: CRUD_ORDER_TYPE,
    stateKey: "message",
  },
  {
    name: "getOrderType",
    method: "get",
    url: CRUD_ORDER_TYPE,
    stateKey: "data",
  },
  {
    name: "updateOrderType",
    method: "put",
    url: CRUD_ORDER_TYPE,
    stateKey: "message",
  },
  {
    name: "deleteOrderType",
    method: "delete",
    url: CRUD_ORDER_TYPE,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
"orderType",
 apiConfig, 
 customReducers);
const orderTypeSlice = slice;

export default orderTypeSlice.reducer;

export const {
  addOrderType,
  getOrderType,
  updateOrderType,
  deleteOrderType,
} = thunks;

export const { rowSelect } = actions;
